<template lang='pug'>
li.articleCard-item(@click="goTo" :class='inactiveClass')
  //- top section of articleCard
  .articleCard-top
    .articleCard-image
      .articleCard-imageBackground(v-if="info.thumbnailUrl" :style='"background-image: url(" + info.thumbnailUrl  + "),url(" + info.category.thumbnailUrl + ");"')
      .articleCard-imageBackground(v-else-if="info.category && info.category.thumbnailUrl" :style='"background-image: url(" + info.category.thumbnailUrl + ");"')
      .articleCard-imageBackground(v-else :style="defaultImage")
    .articleCard-tag(:class="getTagClass(info.tag.id, 'articleCard-tag')") {{ info.tag[$store.state.lang] }}

  //- bottom section of articleCard
  .articleCard-middle
    v-clamp.articleCard-text.heading-cardTitle(@click="goTo" autoresize :max-lines="2") {{ info.content }}

    .articleCard-info
      .articleNoThumbnail-time
        .color--greyBlue90 {{ time }}
      .articleNoThumbnail-report.show--bigScreens
        i.icon-report2.articleNoThumbnail-icon
        .color--greyBlue90 {{ info.reporterCount}}

      .articleNoThumbnail-follow.show--bigScreens
        //- will show the blue version of the eye icon when isFollowing is true
        i.articleNoThumbnail-icon.icon-follow
        //- will change text color to blue when isFollowing is true
        .color--greyBlue90 {{ info.followerCount }}

  .articleCard-bottom
    .articleCard-dot(:class="getTagClass(info.tag.id, 'articleCard-dot')")
    .articleCard-info2(v-if="info.comments.length > 0")
      span {{ info.comments[0].partner.name}}
      span(v-if="info.comments.length > 1") ...
        span {{ "(" + info.comments.length + ")" }}
</template>

<script>
import { getTime, getTagClass } from '@/plugins/tool.js'
import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp
  },
  props: {
    info: Object
  },
  computed: {
    time() {
      // if (this.type == "latestArticles")
      //   return getTime(this.info.createdAt)
      // else
        return getTime(this.info.updatedAt)
    },
    isFollowing() {
      return this.$route.path === '/category' && this.$route.query.type === 'followingArticles'
    },
    inactiveClass() {
      return this.isActive ? '' : 'table-row--inactive'
    },
    isActive() {
      if (!this.isFollowing) return true
      return this.info.tag.id !== 1
    },
    defaultImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/category/fig-default-2.png');";
    }
  },
  methods: {
    getTagClass(tagId, className) {
      return getTagClass(tagId, className, true)
    },
    goTo() {
      if (!this.isActive) return
      this.$router.push({
        "path": "/news",
        "query": {
          "categoryId": this.info.category.id,
          "articleId": this.info.id
        }
      })
    },
  }
}
</script>
<style scoped src='./table_item.vue.css'></style>
